/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Contentful content-preview shared constants (isomorphic — safe for both the
 * app bundle and the SSR/express server).
 *
 * Preview is URL-scoped and cookie-less: the preview secret arrives once in the
 * `?secret=` of a `/{site}/preview/<slug>` URL (e.g. from Contentful's "Open
 * preview" link). The client captures it into memory, strips it from the URL bar,
 * and echoes it to the same-origin proxy via `PREVIEW_HEADER_NAME` on each
 * Preview API request. The proxy validates the raw secret server-side and injects
 * the Contentful Preview API token — so the *token* never reaches the browser.
 *
 * @see pwa-contentful/app/utils/preview-secret.js (in-memory capture/strip)
 * @see king-living/server/middleware/contentful-graphql.js (proxy + validation)
 */

/** Same-origin server proxy that injects the Contentful Preview API token. */
export const PREVIEW_PROXY_PATH = '/server/contentful/graphql';

/**
 * Request header the client uses to send the preview secret to the proxy. Needed
 * because PWA Kit strips the incoming `Cookie` header (allowCookies:false), and we
 * deliberately do not persist the secret in a cookie — it lives in memory only.
 */
export const PREVIEW_HEADER_NAME = 'x-amb-preview-secret';
